import { CartRoutingService } from '../routing'
import { CartService } from '../services/CartService'
import { useCartStore } from '../store'
import { CartSupport } from '../support/CartSupport'

export const useCartModule = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(CartService)
    },
    get store() {
      return useCartStore()
    },
    get routing() {
      return alt.get(CartRoutingService)
    },
    get support() {
      return alt.get(CartSupport)
    },
  }
}
